export function RequirementsProgress({ reqs, counts }) {
  const n = reqs.length;
  const pct = (k) => (n ? (counts[k] / n) * 100 : 0);
  return (
    <div className="mb-3" data-testid="requirements-progress">
      <div className="flex items-center justify-between text-xs mb-1 gap-3 flex-wrap">
        <span className="text-slate-300">Bid scope — SteelForgeAI pre-selects core steel scope; review the amber items and override anything.</span>
        <span className="font-mono text-slate-400" data-testid="requirements-counter"><span className="text-emerald-400">{counts.included}</span> / {n} included</span>
      </div>
      <div className="h-1.5 bg-slate-800 rounded overflow-hidden flex">
        <div className="h-full bg-emerald-500 transition-all" style={{ width: `${pct("included")}%` }} />
        <div className="h-full bg-amber-500 transition-all" style={{ width: `${pct("needs_review")}%` }} />
        <div className="h-full bg-red-500/70 transition-all" style={{ width: `${pct("excluded")}%` }} />
      </div>
      <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-[11px] font-mono text-slate-400" data-testid="scope-legend">
        <span><span className="text-sky-300">{counts.recommended}</span> SteelForgeAI recommended</span>
        <span><span className="text-emerald-400">{counts.confirmed}</span> confirmed / overridden by estimator</span>
        <span><span className="text-amber-300">{counts.needs_review}</span> need review</span>
        <span><span className="text-red-400">{counts.excluded}</span> excluded (playbook / engineering / estimator)</span>
      </div>
      {counts.needs_review > 0 && <div className="mt-2 text-[11px] text-amber-300/90 border border-amber-500/30 bg-amber-500/5 rounded px-2 py-1" data-testid="needs-review-banner">{counts.needs_review} requirement{counts.needs_review > 1 ? "s" : ""} need{counts.needs_review > 1 ? "" : "s"} review — printed as "Needs review" in the PDF / DOCX report, not as an exclusion. Tick to include or strike with a note.</div>}
    </div>
  );
}

const chip = (on, cls = "border-amber-500 text-amber-400") => `text-[11px] px-2 py-1 rounded border ${on ? cls : "border-slate-700 text-slate-400 hover:text-slate-200"}`;

export function CategoryFilter({ categories, reqs, cat, setCat, onlyOpen, setOnlyOpen }) {
  const open = (c) => reqs.filter((r) => r.category === c && r.scope?.state === "needs_review").length;
  return (
    <div className="flex flex-wrap gap-1.5 mb-3">
      <button onClick={() => setCat("")} className={chip(!cat)}>All</button>
      {categories.map((c) => <button key={c} onClick={() => setCat(c)} className={chip(cat === c)} data-testid={`req-cat-${c.replace(/[^a-z]/gi, "-").toLowerCase()}`}>{c} {open(c) > 0 && <span className="text-amber-400/80">{open(c)}</span>}</button>)}
      <button onClick={() => setOnlyOpen(!onlyOpen)} className={`ml-auto ${chip(onlyOpen, "border-amber-500 text-amber-400")}`} data-testid="req-only-open-toggle">{onlyOpen ? "Showing needs review only" : "Needs review only"}</button>
    </div>
  );
}
